import { TranslateService } from '@ngx-translate/core';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BmsjHipsterSharedModule } from '../shared.module';

@Component({
    selector: 'jhi-modal-stock-id-prefix',
    standalone: true,
    imports: [
        BmsjHipsterSharedModule
    ],
    template: `
        <jhi-modal [title]="title">
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <form name="form" #f="ngForm">
                            <div class="mb-3 row">
                                <label for="stockIdPrefix" class="col-4 col-form-label">
                                    <span jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix">Stock ID Prefix</span>
                                    <i class="fa fa-info-circle col-1 help-icon ms-3" data-bs-toggle="tooltip" data-bs-placement="top" title="{{ 'inventoryManagerApp.lot.create.field.stock.id.title' | translate }}"></i>
                                </label>
                                <div class="col-6">
                                    <input type="text" jhi-stockIdPrefixValidator class="form-control" name="stockIdPrefix"
                                           id="stockIdPrefix" [(ngModel)]="model.stockIdPrefix" #stockIdPrefix="ngModel">
                                    <div class="invalid-feedback d-block" *ngIf="stockIdPrefix.invalid">
                                        <small jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix.error"></small>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()">
                    <span class="fa fa-ban"></span>&nbsp;<span>{{ cancelLabel }}</span>
                </button>
                <button (click)="confirm()" [disabled]="f.form.invalid" class="btn btn-primary">
                    <span class="fa fa-save"></span>&nbsp;<span>{{ confirmLabel }}</span>
                </button>
            </div>
        </jhi-modal>
    `
})
export class ModalStockIdPrefixComponent {
    title = this.translateService.instant('inventoryManagerApp.lot.generate.stock.ids.title');
    @Input() cancelLabel = this.translateService.instant('cancel');
    @Input() confirmLabel = this.translateService.instant('confirm');
    model = { stockIdPrefix: '' };

    constructor(private modal: NgbActiveModal,
                private translateService: TranslateService) {
    }

    confirm() {
        this.modal.close(this.model);
    }

    dismiss() {
        this.modal.dismiss();
    }
}
